import { ReactNode, useLayoutEffect } from 'react';
import { useCurrentUser } from './useCurrentUser';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { sessionChanged } from '../store/session';

export default function SessionBoundary({ children }: { children: ReactNode }) {
    const { identity } = useCurrentUser();
    const session = useAppSelector(state => state.session);
    const dispatch = useAppDispatch();
    useLayoutEffect(() => {
        if (!session.initialized || session.identity !== identity) dispatch(sessionChanged(identity));
    }, [dispatch, identity, session.identity, session.initialized]);
    if (!session.initialized || session.identity !== identity) return null;
    return <>{children}</>;
}
